import { createClient, type SupabaseClient } from "@supabase/supabase-js";

// Supabase configuration — the anon key is safe to expose publicly (it's
// designed for client-side use with Row Level Security enabled).
// Env vars (VITE_SUPABASE_URL / VITE_SUPABASE_ANON_KEY) override these
// hardcoded defaults if set, which is useful for local dev with a different project.

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL || "https://lgtikmvmvcyjsqyolrjj.supabase.co";
const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY || "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImxndGlrbXZtdmN5anNxeW9scmpqIiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODYxMDEwMTIsImV4cCI6MjEwMTY3NzAxMn0.dJrhTqZRheKxRJ5x2tCn4SsWp-ll_e90wMuamUZ6h3w";

export const supabase: SupabaseClient = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);
export const isSupabaseConfigured = true;
